import { EmojiPicker } from './components/EmojiPicker';
import { WIZARD_CATEGORIES, WIZARD_NICHES } from './constants';
import { inputStyle, categoryBtnStyle } from './wizardStyles';
import { haptic } from '../../utils/haptic';

export interface Step1Data {
  emoji: string;
  project_title: string;
  category: string;
  niche_type: string;
}

export function WizardStep1({
  data,
  onPatch,
}: {
  data: Step1Data;
  onPatch: (patch: Partial<Step1Data>) => void;
}) {
  return (
    <div style={{ paddingBottom: 100 }}>
      <div style={{ marginBottom: 16 }}>
        <label style={{ display: 'block', fontSize: '0.75rem', color: 'rgba(255,255,255,0.5)', marginBottom: 6 }}>
          Иконка проекта
        </label>
        <EmojiPicker value={data.emoji} onChange={(iconId) => onPatch({ emoji: iconId })} />
      </div>
      <div style={{ marginBottom: 16 }}>
        <label style={{ display: 'block', fontSize: '0.75rem', color: 'rgba(255,255,255,0.5)', marginBottom: 6 }}>
          Название <span style={{ color: 'var(--accent2, #c084fc)' }}>*</span>
        </label>
        <input
          type="text"
          value={data.project_title}
          onChange={(e) => onPatch({ project_title: e.target.value })}
          placeholder="Введите название проекта..."
          style={inputStyle}
          onFocus={(e) => (e.target.style.borderColor = 'rgba(180,100,255,0.35)')}
          onBlur={(e) => (e.target.style.borderColor = 'rgba(255,255,255,0.07)')}
        />
      </div>
      <div style={{ marginBottom: 16 }}>
        <label style={{ display: 'block', fontSize: '0.75rem', color: 'rgba(255,255,255,0.5)', marginBottom: 8 }}>
          Категория <span style={{ color: 'var(--accent2, #c084fc)' }}>*</span>
        </label>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
          {WIZARD_CATEGORIES.map((c) => (
            <button
              key={c.value}
              type="button"
              style={categoryBtnStyle(data.category === c.value)}
              onClick={() => { haptic.select(); onPatch({ category: c.value }); }}
            >
              {c.label}
            </button>
          ))}
        </div>
      </div>
      <div>
        <label style={{ display: 'block', fontSize: '0.75rem', color: 'rgba(255,255,255,0.5)', marginBottom: 8 }}>
          Ниша <span style={{ fontSize: '0.7rem', opacity: 0.6 }}>(необязательно)</span>
        </label>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
          {WIZARD_NICHES.map((n) => (
            <button
              key={n.value}
              type="button"
              style={categoryBtnStyle(data.niche_type === n.value)}
              onClick={() => { haptic.select(); onPatch({ niche_type: data.niche_type === n.value ? '' : n.value }); }}
            >
              {n.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
